(() => {
  'use strict';
  const initialize = root => {
    root.querySelectorAll('[data-pdp-gallery]').forEach(gallery => {
      if (gallery.dataset.pdpReady) return;
      const opener = gallery.querySelector('[data-pdp-open]');
      const main = gallery.querySelector('.hf-product-gallery__main');
      const thumbs = [...gallery.querySelectorAll('[data-pdp-thumb]')];
      const viewer = gallery.querySelector('[data-pdp-viewer]');
      if (!opener || !main || !viewer || !thumbs.length) return;
      gallery.dataset.pdpReady = 'true';
      const canvas = viewer.querySelector('[data-pdp-canvas]');
      const full = viewer.querySelector('[data-pdp-full-image]');
      const zoomIn = viewer.querySelector('[data-pdp-zoom-in]');
      const zoomOut = viewer.querySelector('[data-pdp-zoom-out]');
      const close = viewer.querySelector('[data-pdp-close]');
      const rail = gallery.querySelector('[data-pdp-thumbnails]');
      let index = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
      let scale = 1;
      let start = null;
      let drag = null;
      let moved = false;
      let restoreFocus = null;
      const counter = () => {
        const text = (index + 1) + ' / ' + thumbs.length;
        gallery.querySelector('[data-pdp-counter]').textContent = text;
        viewer.querySelector('[data-pdp-viewer-counter]').textContent = text;
      };
      const setZoom = value => {
        scale = Math.max(1, Math.min(3, value));
        full.style.width = (scale * 100) + '%';
        full.style.height = (scale * 100) + '%';
        canvas.dataset.zoomed = String(scale > 1);
        viewer.querySelector('[data-pdp-zoom-level]').textContent = Math.round(scale * 100) + '%';
        zoomIn.disabled = scale >= 3;
        zoomOut.disabled = scale <= 1;
        if (scale === 1) { canvas.scrollLeft = 0; canvas.scrollTop = 0; }
      };
      const updateFull = () => {
        full.src = thumbs[index].dataset.full;
        full.alt = thumbs[index].dataset.alt;
        full.width = Number(thumbs[index].dataset.width) || 1200;
        full.height = Number(thumbs[index].dataset.height) || 1200;
        setZoom(1);
      };
      const revealThumb = () => {
        const selected = thumbs[index];
        const left = selected.offsetLeft - rail.offsetLeft;
        if (left < rail.scrollLeft) rail.scrollLeft = left;
        else if (left + selected.offsetWidth > rail.scrollLeft + rail.clientWidth) {
          rail.scrollLeft = left + selected.offsetWidth - rail.clientWidth;
        }
      };
      const select = (next, focus = false) => {
        index = (next + thumbs.length) % thumbs.length;
        const thumb = thumbs[index];
        thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
        main.srcset = thumb.dataset.srcset;
        main.src = thumb.dataset.src;
        main.alt = thumb.dataset.alt;
        main.width = Number(thumb.dataset.width) || 1200;
        main.height = Number(thumb.dataset.height) || 1200;
        opener.href = thumb.dataset.full;
        counter();
        revealThumb();
        if (viewer.open) updateFull();
        if (focus) thumb.focus({ preventScroll: true });
      };
      const step = direction => select(index + direction);
      gallery.querySelector('[data-pdp-previous]').addEventListener('click', () => step(-1));
      gallery.querySelector('[data-pdp-next]').addEventListener('click', () => step(1));
      viewer.querySelector('[data-pdp-viewer-previous]').addEventListener('click', () => step(-1));
      viewer.querySelector('[data-pdp-viewer-next]').addEventListener('click', () => step(1));
      thumbs.forEach((thumb, position) => {
        thumb.addEventListener('click', () => select(position));
        thumb.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = position + 1;
          if (event.key === 'ArrowLeft') next = position - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = thumbs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(next, true);
        });
      });
      opener.addEventListener('click', event => {
        if (moved) { event.preventDefault(); moved = false; return; }
        if (typeof viewer.showModal !== 'function') return;
        event.preventDefault();
        restoreFocus = document.activeElement;
        updateFull();
        viewer.showModal();
        document.documentElement.classList.add('hf-pdp-viewer-open');
        close.focus({ preventScroll: true });
      });
      close.addEventListener('click', () => viewer.close());
      viewer.addEventListener('close', () => {
        moved = false;
        start = null;
        drag = null;
        canvas.dataset.dragging = 'false';
        document.documentElement.classList.remove('hf-pdp-viewer-open');
        setZoom(1);
        if (restoreFocus?.isConnected) restoreFocus.focus({ preventScroll: true });
      });
      viewer.addEventListener('click', event => {
        if (event.target !== viewer) return;
        const bounds = viewer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) viewer.close();
      });
      viewer.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' && scale === 1) { event.preventDefault(); step(1); }
        if (event.key === 'ArrowLeft' && scale === 1) { event.preventDefault(); step(-1); }
        if (event.key === '+' || event.key === '=') { event.preventDefault(); setZoom(scale + 0.5); }
        if (event.key === '-') { event.preventDefault(); setZoom(scale - 0.5); }
        if (event.key === '0') { event.preventDefault(); setZoom(1); }
      });
      zoomIn.addEventListener('click', () => setZoom(scale + 0.5));
      zoomOut.addEventListener('click', () => setZoom(scale - 0.5));
      full.addEventListener('click', () => {
        if (moved) { moved = false; return; }
        if (scale === 1) setZoom(2);
      });
      canvas.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || scale === 1 || event.button !== 0) return;
        moved = false;
        drag = { x: event.clientX, y: event.clientY, left: canvas.scrollLeft, top: canvas.scrollTop };
        canvas.dataset.dragging = 'true';
        canvas.setPointerCapture(event.pointerId);
      });
      canvas.addEventListener('pointermove', event => {
        if (!drag) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 5) moved = true;
        canvas.scrollLeft = drag.left - dx;
        canvas.scrollTop = drag.top - dy;
      });
      const finishDrag = () => { drag = null; canvas.dataset.dragging = 'false'; };
      canvas.addEventListener('pointerup', finishDrag);
      canvas.addEventListener('pointercancel', finishDrag);
      const swipeStart = event => {
        if (event.touches.length !== 1 || (viewer.open && scale !== 1)) return;
        moved = false;
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      };
      const swipeEnd = event => {
        if (!start) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          moved = true;
          step(dx < 0 ? 1 : -1);
        }
      };
      for (const target of [opener, canvas]) {
        target.addEventListener('touchstart', swipeStart, { passive: true });
        target.addEventListener('touchend', swipeEnd, { passive: true });
        target.addEventListener('touchcancel', () => { start = null; }, { passive: true });
      }
      counter();
      revealThumb();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
